import React from 'react';
import { Form, Input, Button } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import './Login.css';
import { useDispatch } from 'react-redux';
import { setMessage } from '../../../redux/message.reducer';
import axios from 'axios';
import { setAuth } from '../../../redux/auth.reducer';

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .required('Required')
    .email('Invalid email address'),
  password: Yup.string()
    .required('Required'),
});

export default function Login() {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: { email: '', password: '' },
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      try {
        const response = await axios.post('/auth/login', values);
        if (response.status === 200) {
          dispatch(setAuth({ user: response.data.user, token: response.data.token }));
          dispatch(setMessage({ message: 'Login successful', type: 'success' }));
        }
      } catch (error) {
        dispatch(setMessage({ message: error.response.data.error, type: 'error' }));
      }
    },
  });

  return (
    <div className="login-page">
      <div className="login-form-panel">
        <div className="login-form-wrapper">
          <div className="login-branding">
            <img src="/KOSHA-logo.png" alt="Kosha" className="login-logo" />
            <h1 className="login-brand-name">Kosha</h1>
            <p className="login-brand-tagline">Orders, tasks, notifications</p>
          </div>
          <h2 className="login-title">Welcome back</h2>
          <p className="login-subtitle">Sign in to your account to continue</p>

          <Form
            layout="vertical"
          >
            <Form.Item
              label="Email"
              help={formik.touched.email && formik.errors.email}
              validateStatus={formik.touched.email && formik.errors.email ? 'error' : ''}
            >
              <Input
                name="email"
                type="email"
                size="large"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="you@company.com"
                autoComplete="email"
              />
            </Form.Item>
            <Form.Item
              label="Password"
              help={formik.touched.password && formik.errors.password}
              validateStatus={formik.touched.password && formik.errors.password ? 'error' : ''}
            >
              <Input.Password
                name="password"
                size="large"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0, marginTop: '1.5rem' }}>
              <Button
                type="primary"
                size="large"
                block
                loading={formik.isSubmitting}
                className="app-btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  formik.handleSubmit();
                }}
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}
